export function setProveedores(state, proveedores) {
    state.proveedores = proveedores
}




export function actListProveedores(state, proveedor) {
    if (proveedor !== null) {
        const index = state.proveedores.findIndex(r => r.id === proveedor.id)
        if (index != -1) {
            state.proveedores.splice(index, 1, proveedor)   
        }
    }
  
}

export function actDeleteListProveedores(state, id) {
   
    if (id != null) {
        const index = state.proveedores.findIndex(r => r.id === id)
        if (index != -1) {
            state.proveedores.splice(index, 1)
        }
    }
}



export function setProveedorSelec(state, proveedor) {
    state.proveedorSelec = proveedor
}




